import { useEffect, useRef } from "react";
import { ISearchQuick, ISearchQuickResults } from "../types/ISearch";
import { NavItems } from "../types/User/IUserProfile";

const useFocusInput = () => {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    ref.current?.focus();
  });
  return ref;
};

const useFocusTextArea = () => {
  const ref = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    ref.current?.focus();
  });
  return ref;
};

function any(iterable) {
  for (let index = 0; index < iterable.length; index++) {
    if (iterable[index]) return true;
  }
  return false;
}

export function trimChar(str, ch) {
  if (!str?.length) return str;
  var start = 0,
    end = str?.length;

  while (start < end && str[start] === ch) ++start;

  while (end > start && str[end - 1] === ch) --end;

  return start > 0 || end < str.length ? str.substring(start, end) : str;
}

const isDate = function (date) {
  return date instanceof Date && !isNaN(date.valueOf());
};

const mouseClickEvents = ["mousedown", "click", "mouseup"];
function simulateMouseClick(element) {
  mouseClickEvents.forEach((mouseEventType) =>
    element.dispatchEvent(
      new MouseEvent(mouseEventType, {
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1,
      })
    )
  );
}
function removeTrailingSlash(str) {
  return str.endsWith("/") ? str.slice(0, -1) : str;
}
/** Return Object if it matches number in ID attribute. The array objects must have an attribute of ID. */
function ObjectExistsInArray(arr: any[], ID: number) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].ID === ID) {
      return { found: arr[i], index: i };
    }
    return null;
  }
}
export function FlattenAndAddCategoryObjectsToQuickSearchResults(
  quickSearchObj: ISearchQuick
) {
  const resultsArr: ISearchQuickResults[] = [];
  const maxResults = 50;
  let i = 0;
  quickSearchObj.Categories.forEach((category) => {
    const resultsCount =
      category.ResultCount > maxResults ? maxResults : category.ResultCount;
    resultsArr.push({
      Id: i,
      Display: category.Display,
      ResultCount: resultsCount,
      Url_Format: "#",
      isCategory: true,
    });
    i++;
    category.Results.slice(0, maxResults).forEach((result) => {
      resultsArr.push({
        ...result,
        Url_Format: category.Url_Format,
        isCategory: false,
      });
    });
  });
  return resultsArr;
}
export function AddTextAndItemsAttrToNavItems(Nav_Items: NavItems[]) {
  return Nav_Items?.map((item1) => {
    return {
      ...item1,
      text: item1.Text,
      items: [...item1.Nav_Items]?.map((item2) => {
        return {
          ...item2,
          text: item2.Text,
          items: [...item2.Nav_Items]?.map((item3) => {
            return {
              ...item3,
              text: item3.Text,
              items: [...item3.Nav_Items].map((item4) => {
                return { ...item4, text: item4.Text }
              }),
            }
          }),
        };
      }),
    };
  });
}
export function AddTextAndItemsAttrToHamburgerItems(Nav_Items: NavItems[]) {
  return Nav_Items.map((item1) => {
    return {
      ...item1,
      text: item1.Text,
      items: [...item1.Nav_Items]?.map((item2) => {
        return {
          ...item2,
          text: item2.Text,
          items: [...item2.Nav_Items]?.map((item3) => {
            return {
              ...item3,
              text: item3.Text,
              items: [...item3.Nav_Items]?.map((item4) => {
                return {
                  ...item4,
                  text: item4.Text,
                  items: item4.Nav_Items.map(n4 => {
                    return { text: n4.Text }
                  })
                };
              }),
            };
          }),
        };
      }),
    };
  });
}

function getTicketStateClassName(state: string) {
  switch (state?.toLowerCase()) {
    case "new":
      return "ticket-state-new";
    case "current":
      return "ticket-state-current";
    case "response late":
    case "resolve late":
      return "ticket-state-late";
    case "response at risk":
    case "resolve at risk":
      return "ticket-state-at-risk";
  }

  return "ticket-state-current";
}

function toDigital(minutes, negativeBrackets?) {
  if (minutes === 0) return "0:00";
  if (!minutes) return "";
  let convert = minutes < 0 && negativeBrackets ? minutes * -1 : minutes;
  let digital =
    Math.floor(convert / 60) + ":" + (convert % 60).toFixed().padStart(2, "0");

  return minutes < 0 && negativeBrackets ? `(${digital})` : digital;
}

///Converts Hours and Minutes to Minutes ie. 1:20 = 80min
function toMinutes(time) {
  var strMin;
  var strHour;
  if (time.indexOf(":") > -1) {
    strHour = parseInt(time.substr(0, time.indexOf(":")));
    strMin = parseInt(time.substr(time.indexOf(":") + 1).padEnd(2, "0"));
  } else if (time.indexOf(".") > -1) {
    //1.5 = 1:30
    strHour = parseFloat(time);
  } else {
    strHour = parseInt(time);
    strMin = parseInt("0");
  }
  var minutes = 0;
  var hours = 0;

  if (!isNaN(strMin)) {
    minutes = strMin;
  }
  if (!isNaN(strHour)) {
    hours = strHour;
  }

  return hours * 60 + minutes;
}

function getLocaleDateFormat() {
  const formats = {
    "af-ZA": "yyyy/MM/dd",
    "am-ET": "d/M/yyyy",
    "ar-AE": "dd/MM/yyyy",
    "ar-BH": "dd/MM/yyyy",
    "ar-DZ": "dd-MM-yyyy",
    "ar-EG": "dd/MM/yyyy",
    "ar-IQ": "dd/MM/yyyy",
    "ar-JO": "dd/MM/yyyy",
    "ar-KW": "dd/MM/yyyy",
    "ar-LB": "dd/MM/yyyy",
    "ar-LY": "dd/MM/yyyy",
    "ar-MA": "dd-MM-yyyy",
    "ar-OM": "dd/MM/yyyy",
    "ar-QA": "dd/MM/yyyy",
    "ar-SA": "dd/MM/yy",
    "ar-SY": "dd/MM/yyyy",
    "ar-TN": "dd-MM-yyyy",
    "ar-YE": "dd/MM/yyyy",
    "arn-CL": "dd-MM-yyyy",
    "as-IN": "dd-MM-yyyy",
    "az-Cyrl-AZ": "dd.MM.yyyy",
    "az-Latn-AZ": "dd.MM.yyyy",
    "ba-RU": "dd.MM.yy",
    "be-BY": "dd.MM.yyyy",
    "bg-BG": "dd.M.yyyy",
    "bn-BD": "dd-MM-yy",
    "bn-IN": "dd-MM-yy",
    "bo-CN": "yyyy/M/d",
    "br-FR": "dd/MM/yyyy",
    "bs-Cyrl-BA": "d.M.yyyy",
    "bs-Latn-BA": "d.M.yyyy",
    "ca-ES": "dd/MM/yyyy",
    "co-FR": "dd/MM/yyyy",
    "cs-CZ": "d.M.yyyy",
    "cy-GB": "dd/MM/yyyy",
    "da-DK": "dd-MM-yyyy",
    "de-AT": "dd.MM.yyyy",
    "de-CH": "dd.MM.yyyy",
    "de-DE": "dd.MM.yyyy",
    "de-LI": "dd.MM.yyyy",
    "de-LU": "dd.MM.yyyy",
    "dsb-DE": "d. M. yyyy",
    "dv-MV": "dd/MM/yy",
    "el-GR": "d/M/yyyy",
    "en-029": "MM/dd/yyyy",
    "en-AU": "d/MM/yyyy",
    "en-BZ": "dd/MM/yyyy",
    "en-CA": "dd/MM/yyyy",
    "en-GB": "dd/MM/yyyy",
    "en-IE": "dd/MM/yyyy",
    "en-IN": "dd-MM-yyyy",
    "en-JM": "dd/MM/yyyy",
    "en-MY": "d/M/yyyy",
    "en-NZ": "d/MM/yyyy",
    "en-PH": "M/d/yyyy",
    "en-SG": "d/M/yyyy",
    "en-TT": "dd/MM/yyyy",
    "en-US": "M/d/yyyy",
    "en-ZA": "yyyy/MM/dd",
    "en-ZW": "M/d/yyyy",
    "es-AR": "dd/MM/yyyy",
    "es-BO": "dd/MM/yyyy",
    "es-CL": "dd-MM-yyyy",
    "es-CO": "dd/MM/yyyy",
    "es-CR": "dd/MM/yyyy",
    "es-DO": "dd/MM/yyyy",
    "es-EC": "dd/MM/yyyy",
    "es-ES": "dd/MM/yyyy",
    "es-GT": "dd/MM/yyyy",
    "es-HN": "dd/MM/yyyy",
    "es-MX": "dd/MM/yyyy",
    "es-NI": "dd/MM/yyyy",
    "es-PA": "MM/dd/yyyy",
    "es-PE": "dd/MM/yyyy",
    "es-PR": "dd/MM/yyyy",
    "es-PY": "dd/MM/yyyy",
    "es-SV": "dd/MM/yyyy",
    "es-US": "M/d/yyyy",
    "es-UY": "dd/MM/yyyy",
    "es-VE": "dd/MM/yyyy",
    "et-EE": "d.MM.yyyy",
    "eu-ES": "yyyy/MM/dd",
    "fa-IR": "MM/dd/yyyy",
    "fi-FI": "d.M.yyyy",
    "fil-PH": "M/d/yyyy",
    "fo-FO": "dd-MM-yyyy",
    "fr-BE": "d/MM/yyyy",
    "fr-CA": "yyyy-MM-dd",
    "fr-CH": "dd.MM.yyyy",
    "fr-FR": "dd/MM/yyyy",
    "fr-LU": "dd/MM/yyyy",
    "fr-MC": "dd/MM/yyyy",
    "fy-NL": "d-M-yyyy",
    "ga-IE": "dd/MM/yyyy",
    "gd-GB": "dd/MM/yyyy",
    "gl-ES": "dd/MM/yy",
    "gsw-FR": "dd/MM/yyyy",
    "gu-IN": "dd-MM-yy",
    "ha-Latn-NG": "d/M/yyyy",
    "he-IL": "dd/MM/yyyy",
    "hi-IN": "dd-MM-yyyy",
    "hr-BA": "d.M.yyyy.",
    "hr-HR": "d.M.yyyy",
    "hsb-DE": "d. M. yyyy",
    "hu-HU": "yyyy. MM. dd.",
    "hy-AM": "dd.MM.yyyy",
    "id-ID": "dd/MM/yyyy",
    "ig-NG": "d/M/yyyy",
    "ii-CN": "yyyy/M/d",
    "is-IS": "d.M.yyyy",
    "it-CH": "dd.MM.yyyy",
    "it-IT": "dd/MM/yyyy",
    "iu-Cans-CA": "d/M/yyyy",
    "iu-Latn-CA": "d/MM/yyyy",
    "ja-JP": "yyyy/MM/dd",
    "ka-GE": "dd.MM.yyyy",
    "kk-KZ": "dd.MM.yyyy",
    "kl-GL": "dd-MM-yyyy",
    "km-KH": "yyyy-MM-dd",
    "kn-IN": "dd-MM-yy",
    "ko-KR": "yyyy. MM. dd",
    "kok-IN": "dd-MM-yyyy",
    "ky-KG": "dd.MM.yy",
    "lb-LU": "dd/MM/yyyy",
    "lo-LA": "dd/MM/yyyy",
    "lt-LT": "yyyy.MM.dd",
    "lv-LV": "yyyy.MM.dd.",
    "mi-NZ": "dd/MM/yyyy",
    "mk-MK": "dd.MM.yyyy",
    "ml-IN": "dd-MM-yy",
    "mn-MN": "yy.MM.dd",
    "mn-Mong-CN": "yyyy/M/d",
    "moh-CA": "M/d/yyyy",
    "mr-IN": "dd-MM-yyyy",
    "ms-BN": "dd/MM/yyyy",
    "ms-MY": "dd/MM/yyyy",
    "mt-MT": "dd/MM/yyyy",
    "nb-NO": "dd.MM.yyyy",
    "ne-NP": "M/d/yyyy",
    "nl-BE": "d/MM/yyyy",
    "nl-NL": "d-M-yyyy",
    "nn-NO": "dd.MM.yyyy",
    "nso-ZA": "yyyy/MM/dd",
    "oc-FR": "dd/MM/yyyy",
    "or-IN": "dd-MM-yy",
    "pa-IN": "dd-MM-yy",
    "pl-PL": "dd.MM.yyyy",
    "prs-AF": "dd/MM/yy",
    "ps-AF": "dd/MM/yy",
    "pt-BR": "d/M/yyyy",
    "pt-PT": "dd-MM-yyyy",
    "qut-GT": "dd/MM/yyyy",
    "quz-BO": "dd/MM/yyyy",
    "quz-EC": "dd/MM/yyyy",
    "quz-PE": "dd/MM/yyyy",
    "rm-CH": "dd/MM/yyyy",
    "ro-RO": "dd.MM.yyyy",
    "ru-RU": "dd.MM.yyyy",
    "rw-RW": "M/d/yyyy",
    "sa-IN": "dd-MM-yyyy",
    "sah-RU": "MM.dd.yyyy",
    "se-FI": "d.M.yyyy",
    "se-NO": "dd.MM.yyyy",
    "se-SE": "yyyy-MM-dd",
    "si-LK": "yyyy-MM-dd",
    "sk-SK": "d. M. yyyy",
    "sl-SI": "d.M.yyyy",
    "sma-NO": "dd.MM.yyyy",
    "sma-SE": "yyyy-MM-dd",
    "smj-NO": "dd.MM.yyyy",
    "smj-SE": "yyyy-MM-dd",
    "smn-FI": "d.M.yyyy",
    "sms-FI": "d.M.yyyy",
    "sq-AL": "yyyy-MM-dd",
    "sr-Cyrl-BA": "d.M.yyyy",
    "sr-Cyrl-CS": "d.M.yyyy",
    "sr-Cyrl-ME": "d.M.yyyy",
    "sr-Cyrl-RS": "d.M.yyyy",
    "sr-Latn-BA": "d.M.yyyy",
    "sr-Latn-CS": "d.M.yyyy",
    "sr-Latn-ME": "d.M.yyyy",
    "sr-Latn-RS": "d.M.yyyy",
    "sv-FI": "d.M.yyyy",
    "sv-SE": "yyyy-MM-dd",
    "sw-KE": "M/d/yyyy",
    "syr-SY": "dd/MM/yyyy",
    "ta-IN": "dd-MM-yyyy",
    "te-IN": "dd-MM-yy",
    "tg-Cyrl-TJ": "dd.MM.yy",
    "th-TH": "d/M/yyyy",
    "tk-TM": "dd.MM.yy",
    "tn-ZA": "yyyy/MM/dd",
    "tr-TR": "dd.MM.yyyy",
    "tt-RU": "dd.MM.yyyy",
    "tzm-Latn-DZ": "dd-MM-yyyy",
    "ug-CN": "yyyy-M-d",
    "uk-UA": "dd.MM.yyyy",
    "ur-PK": "dd/MM/yyyy",
    "uz-Cyrl-UZ": "dd.MM.yyyy",
    "uz-Latn-UZ": "dd/MM yyyy",
    "vi-VN": "dd/MM/yyyy",
    "wo-SN": "dd/MM/yyyy",
    "xh-ZA": "yyyy/MM/dd",
    "yo-NG": "d/M/yyyy",
    "zh-CN": "yyyy/M/d",
    "zh-HK": "d/M/yyyy",
    "zh-MO": "d/M/yyyy",
    "zh-SG": "d/M/yyyy",
    "zh-TW": "yyyy/M/d",
    "zu-ZA": "yyyy/MM/dd",
  };

  return formats[navigator.language] || "dd/MM/yyyy";
}

function getLocaleDateTimeFormat() {
  return getLocaleDateFormat() + ' ' + 'HH:mm';
}

export {
  toDigital,
  toMinutes,
  useFocusInput,
  useFocusTextArea,
  any,
  simulateMouseClick,
  ObjectExistsInArray,
  removeTrailingSlash,
  getTicketStateClassName,
  isDate,
  getLocaleDateFormat,
  getLocaleDateTimeFormat
};
